const firstRun = {
  changeDocument: "Change",
  loadedDocuments: "{{count}} / {{total}} documents loaded",
  registeredOnly: "Select two registered documents or paste both specifications, or provide one change report. Mixed document and text inputs are not supported.",
  pastedUnverified: "Pasted text / link to registered documents unverified. You can save candidates, but cannot adopt them.",
  chooseDocument: "Select or replace registered document",
  preview: "View extracted text",
  documentCount: "{{count}} documents found",
  noDocuments: "No matching documents.",
  registerDocument: "Register sources in document management",

  analysisInProgress: 'This analysis is already running. Wait for it to finish, then reopen it from history.',
  rerunBlocked: 'Reviewed or edited rows would be lost. Open the existing results to continue reviewing.',
  sourceChanged: 'A source document changed after analysis. Select the current sources and start a new analysis.',
  sourceVersionChanged: 'A selected document changed before analysis started. Your input is preserved. Select the document again to confirm its current version, then retry.',
  sourcePreviewChanged: 'This document has changed. Select it again to confirm the current version.',
  sourceMissing: 'A source document is no longer available. Select another document and retry.',
  sourceForbidden: 'You no longer have access to a source document. Select an accessible document.',
  sourcePending: 'Source text is still being extracted. Wait for processing to finish and retry.',
  sourceFailed: 'Source text extraction failed. Reprocess the document or choose another source.',
  sourceUnsupported: 'This document format is not supported for analysis. Choose a supported PDF, PowerPoint, Excel, or Word document.',
  sourceEmpty: 'A source has no extracted text. Check the document and choose another source.',
  sourceTooLarge: 'A source exceeds the analysis limit. Split the document and select a smaller source.',
  analysisFailed: 'Analysis failed. Your input is preserved; check the sources and retry.',
  supplementCopied: 'Generated rows copied supplemental context. Review the supplemental context and retry.',
  streamInterrupted: 'The analysis connection ended before completion. Reopen the session from history to check its status before retrying.',
  initializationFailed: 'Analysis finished, but the review workspace could not be opened. Retry opening the results without rerunning analysis.',
  resultsLoadFailed: 'Analysis finished, but results could not be loaded. Retry opening the results without rerunning analysis.',
  returnToInput: 'Stop recovering results and return to input',
  retryResults: 'Retry opening results',
  noChanges: 'Analysis completed. No changes were found.',
};
export default firstRun;
